<template>
  <div>
    <form v-if="showForm" @submit.prevent="onboarding" class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[35rem] mx-auto">
      <h1 class="font-normal text-xl md:text-2xl mb-10 flex items-center justify-center text-center">
        <span>Crea tu cuenta y asocia tu tarjeta para consultar tus viajes</span>
      </h1>
      <LoadingView :loading="loading">
        <div class="form-group mb-6 mt-5">
          <label class="block mb-2" for="user_name">Nombre</label>
          <input 
            v-model="form_onboarding.user_name" 
            @input="validateUser($event)"
            class="form-control form-input form-input-bordered w-full mb-1"
            :class="{ 'form-input-border-error': errors.user_name.length > 0 }" 
            id="user_name"
            type="text" 
            name="user_name" 
            placeholder="Nombre y Apellido"
            autofocus="" 
            required />
          <span class="form-text text-slate-400 w-full">Ingresar nombre y apellido</span>
          <HelpText class="mt-2 text-red-500" v-if="errors.user_name.length > 0">
            {{ errors.user_name }}
          </HelpText>
        </div>
        <div class="form-group mb-6 mt-1">
          <label class="block mb-2" for="user_email">Email</label>
          <input 
            v-model="form_onboarding.user_email" 
            @input="validateEmail"
            class="form-control form-input form-input-bordered w-full mb-1"
            :class="{ 'form-input-border-error': errors.user_email.length > 0 }" 
            id="user_email"
            type="text" 
            name="user_email" 
            placeholder="user@dominio.com"
            autofocus="" 
            required />
          <span class="form-text text-slate-400 w-full">Ingresar correo electrónico</span>
          <HelpText class="mt-2 text-red-500" v-if="errors.user_email.length > 0">
            {{ errors.user_email }}
          </HelpText>
        </div>
        <div class="form-group mb-6 mt-1">
          <label class="block mb-2" for="user_movil">Número Móvil</label>
          <div class="relative">
            <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-">
                <span class=" left-1 top-1 z-10 select-none rounded bg-gray-500 py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase text-white shadow-md shadow-gray-500/20 transition-all hover:shadow-lg hover:shadow-gray-500/40 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none peer-placeholder-shown:pointer-events-none peer-placeholder-shown:bg-blue-gray-500 peer-placeholder-shown:opacity-50 peer-placeholder-shown:shadow-none">+56</span>
            </div>
            <input 
              v-model="form_onboarding.user_movil" 
              @input="checkMovil"
              class="form-control pl-16 form-input form-input-bordered w-full mb-1"
              :class="{ 'form-input-border-error': errors.user_movil.length > 0 }" 
              id="user_movil"
              type="text" 
              name="user_movil" 
              maxlength="9"
              minlength = "9"
              placeholder="912345678"
              required
              autofocus="" 
              />
          </div>    
          <span class="form-text text-slate-400 w-full">Formato número 9 1234 5678</span>
          <HelpText class="mt-2 text-red-500" v-if="errors.user_movil.length > 0">
            {{ errors.user_movil }}
          </HelpText>
        </div>
        <div class="form-group mb-6 mt-1">
          <label class="block mb-2" for="user_password">Contraseña</label>
          <div class="flex items-center">
            <div class="w-full">
                <input 
                  v-model="form_onboarding.user_password" 
                  @input="validateUserPassword"
                  class="form-control form-input form-input-bordered w-full mb-1"
                  :class="{ 'form-input-border-error': errors.user_password.length > 0 }" 
                  id="user_password"
                  :type="show ? 'password' : 'text'"
                  name="user_password" 
                  autofocus="" 
                  required />
            </div>
            <div class="eyeButton ml-2">
              <svg v-if="show" @click="show = !show" width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)" stroke="#14B8A6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.72"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <svg v-if="!show" @click="show = !show" width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </div>
          </div>
          <span class="form-text text-slate-400 w-full">Requiere mínimo de 10 caracteres con al menos una letra minúscula, una letra mayúscula y un carácter especial</span>
          <HelpText class="mt-2 text-red-500" v-if="errors.user_password.length > 0">
            {{ errors.user_password }}
          </HelpText>
          <HelpText class="mt-2 text-red-500 w-full" v-if="errors.user_password_length">
              {{ errors.user_password_length }}
          </HelpText>
        </div>
        <div class="form-group mb-6 mt-1">
          <label class="block mb-2" for="user_password_confirmation">Confirmar contraseña</label>
          <div class="flex items-center">
            <div class="w-full">
              <input 
                  v-model="form_onboarding.user_password_confirmation"
                  @input="validateUserPasswordConfirm"
                  class="form-control form-input form-input-bordered w-full mb-1"
                  :class="{ 'form-input-border-error': errors.user_password_confirmation.length > 0 }"
                  id="user_password_confirmation" 
                  :type="show_confirmation ? 'password' : 'text'"
                  name="user_password_confirmation"
                  autofocus="" 
                  required />
            </div>
            <div class="eyeButton ml-2">
              <svg v-if="show_confirmation" @click="show_confirmation = !show_confirmation" width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" transform="matrix(1, 0, 0, 1, 0, 0)rotate(0)" stroke="#14B8A6"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.72"></g><g id="SVGRepo_iconCarrier"> <path d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
              <svg v-if="!show_confirmation" @click="show_confirmation = !show_confirmation" width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2.99902 3L20.999 21M9.8433 9.91364C9.32066 10.4536 8.99902 11.1892 8.99902 12C8.99902 13.6569 10.3422 15 11.999 15C12.8215 15 13.5667 14.669 14.1086 14.133M6.49902 6.64715C4.59972 7.90034 3.15305 9.78394 2.45703 12C3.73128 16.0571 7.52159 19 11.9992 19C13.9881 19 15.8414 18.4194 17.3988 17.4184M10.999 5.04939C11.328 5.01673 11.6617 5 11.9992 5C16.4769 5 20.2672 7.94291 21.5414 12C21.2607 12.894 20.8577 13.7338 20.3522 14.5" stroke="#14B8A6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
            </div>
          </div>
          <span class="form-text text-slate-400 w-full">Repite la contraseña ingresada previamente</span>
          <HelpText class="mt-2 text-red-500" v-if="errors.user_password_confirmation.length > 0">
              {{ errors.user_password_confirmation }}
          </HelpText>
          <HelpText class="mt-2 text-red-500 w-full" v-if="errors.user_password_confirmation_length">
              {{ errors.user_password_confirmation_length }}
          </HelpText>
        </div>
        <div v-show="overlay" class="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center">
          <div class="relative bg-gray-500/50 w-full h-full"></div>
          <div class="fixed inset-0 flex items-center justify-center">
            <div class="relative bg-white rounded-lg shadow-xl max-w-lg w-full">
              <div class="p-6">
                <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">Términos y condiciones</h3>
                <br>
                <div class="mt-2" style="overflow-y: auto; max-height: 20rem;">
                  <div type="text" class="" readonly v-html="configurations.content"></div>
                </div>
              </div>
              <div class="bg-gray-50 px-4 py-3 rounded-lg sm:flex sm:flex-row-reverse sm:px-6">
                <button 
                  type="button"
                  class="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:w-auto"
                  @click="overlay = !overlay">Cerrar</button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group mb-6 mt-1">
          <input 
            class="relative float-left mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] " 
            type="checkbox" 
            value=""
            v-model="form_onboarding.check" 
            id="termsCondition" 
            required/>
          <label for="termsCondition">
            He leído y acepto <button class="font-semibold text-teal-500" type="button" @click="open">{{ __('Términos y condiciones')}}</button>
          </label>
        </div>
        <DefaultButton class="w-full mt-2.5 flex justify-center" type="submit">
          <span>
            {{ __('Completar registro') }}
          </span>
        </DefaultButton>
        <a @click="backLogin" class="block mt-2.5 mx-0 mb-0 text-gray-500 font-bold text-center cursor-pointer">
          <span> {{ buttonBack }}</span>
        </a>
      </LoadingView>
    </form>

    <div v-if="!showForm">
      <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[35rem] mx-auto">
        <div class="mb-6">
          <div class="svg-container">
            <svg class="svg-content" xmlns="http://www.w3.org/2000/svg" width="300px" height="300px" viewBox="0 0 300 300" version="1.1">
              <defs>
                <filter id="alpha" filterUnits="objectBoundingBox" x="0%" y="0%" width="100%" height="100%">
                  <feColorMatrix type="matrix" in="SourceGraphic" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"/>
                </filter>
                <mask id="mask0">
                  <g filter="url(#alpha)">
                    <rect x="0" y="0" width="300" height="300" style="fill:rgb(0%,0%,0%);fill-opacity:0.988235;stroke:none;"/>
                  </g>
                </mask>
                <clipPath id="clip1">
                  <rect x="0" y="0" width="300" height="300"/>
                </clipPath>
                <g id="surface6" clip-path="url(#clip1)">
                  <path style=" stroke:none;fill-rule:nonzero;fill:rgb(34.901961%,71.372549%,64.313725%);fill-opacity:1;" d="M 270.539062 154.167969 C 270.539062 227.535156 211.058594 287.011719 137.691406 287.011719 C 64.320312 287.011719 4.84375 227.535156 4.84375 154.167969 C 4.84375 80.796875 64.320312 21.320312 137.691406 21.320312 C 211.058594 21.320312 270.539062 80.796875 270.539062 154.167969 Z M 270.539062 154.167969 "/>
                </g>
              </defs>
              <g id="surface2">
                <use xlink:href="#surface6" mask="url(#mask0)"/>
                <path style="fill:none;stroke-width:1.560861;stroke-linecap:butt;stroke-linejoin:miter;stroke:rgb(100%,100%,100%);stroke-opacity:1;stroke-miterlimit:4;" d="M 3.190417 40.690417 L 6 43.5 L 11.150833 36.476042 " transform="matrix(18.75,0,0,18.75,0,-600)"/>
              </g>
            </svg>
          </div>
          <h1 class="font-normal text-3xl md:text-2xl mb-2 flex items-center justify-center">
            <span>Registro Correcto.</span>
          </h1>

          <p class="text-center text-2xl text-gray-500 mb-2">Se redireccionará para iniciar sesión.</p>
          <LoadingView :loading="true" style="min-height: 3rem !important">
          </LoadingView>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  props: {
    register: String, // Define el tipo de la propiedad
  },
  data: () => ({
    form_onboarding: Nova.form({
      user_name: '',
      user_email: '',
      user_password: '',
      user_password_confirmation: '',
      user_movil: '',
      configuration: '',
      check: false
    }),
    errors: {
      user_name: '',
      user_email: '',
      user_password_length: '',
      user_password_confirmation_length: '',
      user_password: '',
      user_password_confirmation: '',
      user_movil: '',
    },
    showOnboarding: false,
    show: 'password',
    show_confirmation: 'password',
    path: '/',
    configurations: '',
    dialog: false,
    overlay: false,
    loading: false,
    buttonBack: 'Regresar a Inicio de sesión.',
    showForm: true
  }),
  methods: {
    async onboarding() {
      try {
        if (this.validateErrors()) {
          this.loading = true
          const response = await Nova.request().post(Nova.url('/onboard'), this.form_onboarding)
          if (response.data.status == 'ok') {
            setTimeout(() => {
              Nova.visit('/login')
            }, 4000)

            for (let key in this.form_onboarding) {
              if (this.form_onboarding.hasOwnProperty(key)) {
                this.form_onboarding[key] = ''
                if(key == 'check'){
                  this.form_onboarding[key] = false
                }
              }
            }
            this.showForm = false
            //Nova.success('Cuenta creada exitosamente');
          }
        } else {
          Nova.error('Valide la información ingresada.');
        }
      } catch (error) {
        if (error.response?.status === 500) {
          this.loading = false
          Nova.error(this.__('There was a problem submitting the form.'))
        } else if (error.response && error.response.status === 422) {
          this.loading = false
          const responseData = error.response.data.errors;

          for (let key in this.errors) {
            if (this.errors.hasOwnProperty(key)) {
              this.errors[key] = '';
            }
          }

          for (let index in responseData) {
            if (responseData.hasOwnProperty(index)) {
              if (index in this.errors) {
                this.errors[index] = `${responseData[index]}`
              }
            }
          }
        } else {
          this.loading = false
          console.error('Error:', error.message);
        }
      }
    },
    async backLogin() {
      Nova.visit('/login')
    },
    open() {
      this.dialog = true
      this.overlay = true
    },
    close() {
      this.dialog = false
      this.overlay = false
    },
    outsideClick($event) {
      if ($event.target.id == 'outside') {
        this.dialog = false
        this.overlay = false
      }
    },
    validateUser(event) {
      this.errors.user_name = this.form_onboarding.user_name.length === 0 ? '' : this.form_onboarding.user_name.length >= 3 ? '' : 'Nombre debe contener más de 2 letras'
      let inputValue = event.target.value
      let regexPattern = /^[a-zA-Z ]+$/;
      if (inputValue.match(regexPattern)) {
        this.form_onboarding.user_name = inputValue
      } else {
        this.form_onboarding.user_name = inputValue.substring(0, inputValue.length - 1);
      }
    },
    validateEmail() {
      const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
      if (this.form_onboarding.user_email.length != 0) {
        this.errors.user_email = regex.test(this.form_onboarding.user_email) ? "" : "Formato email invalido.";
      } else {
        this.errors.user_email = ''
      }
    },
    validateUserPassword() {
      if (this.form_onboarding.user_password.length != 0) {
        if (this.form_onboarding.user_password === this.form_onboarding.user_password_confirmation) {
          this.errors.user_password = ''
          this.errors.user_password_confirmation = ''
        } else {
          this.errors.user_password = 'Las contraseñas deben ser iguales'
          this.errors.user_password_confirmation = 'Las contraseñas deben ser iguales'
        }
      } else {
        this.errors.user_password = ''
        this.errors.user_password_confirmation = ''
      }
      this.validateUserPasswordLength()
    },
    validateUserPasswordLength() {
      if (this.form_onboarding.user_password.length != 0) {
        if (this.form_onboarding.user_password.length >= 10) {
          this.errors.user_password_length = ''
        } else {
          this.errors.user_password_length = 'La contraseña debe tener mas de 10 caracteres.'
        }
      } else {
        this.errors.user_password_length = ''
      }
    },
    validateUserPasswordConfirm() {
      if (this.form_onboarding.user_password_confirmation.length != 0) {
        if (this.form_onboarding.user_password === this.form_onboarding.user_password_confirmation) {
          this.errors.user_password = ''
          this.errors.user_password_confirmation = ''
        } else {
          this.errors.user_password_confirmation = 'Las contraseñas deben ser iguales'
          this.errors.user_password = 'Las contraseñas deben ser iguales'
        }
      } else {
        this.errors.user_password_confirmation = ''
        this.errors.user_password = ''
      }
      this.validateUserPasswordConfirmLength()
    },
    validateUserPasswordConfirmLength() {
      if (this.form_onboarding.user_password_confirmation.length != 0) {
        if (this.form_onboarding.user_password_confirmation.length >= 10) {
          this.errors.user_password_confirmation_length = ''
        } else {
          this.errors.user_password_confirmation_length = 'La contraseña debe tener mas de 10 caracteres.'
        }
      } else {
        this.errors.user_password_confirmation_length = ''
      }
    },
    checkMovil(e){
      if(!isNaN(e.target.value)){
          this.form_onboarding.user_movil = e.target.value
          this.errors.user_movil = this.form_onboarding.user_movil.length === 0 ? '': this.form_onboarding.user_movil.length >= 9 ? '':'Móvil debe tener 9 dígitos. '
      }else{
          this.form_onboarding.user_movil = e.target.value.substring(0, e.target.value.length - 1)
          this.errors.user_movil = this.form_onboarding.user_movil.length === 0 ? '': this.form_onboarding.user_movil.length >= 9 ? '':'Móvil debe tener 9 dígitos. '
      }
    },
    toFormatRut(event) {
      if (event.inputType == 'deleteContentBackward') {
        let value = event.target.value
        if (value.substr(-1) == '.' || value.substr(-1) == '-') {
          value = value.substring(0, value.length - 1);
        }
        this.form_onboarding.merchant_rut = value
        if (this.form_onboarding.merchant_rut.length >= 11) {
          this.validateFormatRut()
        }
      } else {
        let endChar = event.target.value.charAt(event.target.value.length - 1)
        if (this.deleteLetters(endChar)) {
          if (this.form_onboarding.merchant_rut.length === 1 && event.target.value == '0') {
            this.form_onboarding.merchant_rut = ''
          } else if (this.form_onboarding.merchant_rut.length > 12) {
            this.form_onboarding.merchant_rut = event.target.value.substring(0, event.target.value.length - 1)
          } else {
            let value = event.target.value.replace(/\./g, '').replace('-', '');
            if (value.match(/^(\d{2})(\d{3}){2}(\w{1})$/)) {
              value = value.replace(/^(\d{2})(\d{3})(\d{3})(\w{1})$/, '$1.$2.$3-$4');
            }
            else if (value.match(/^(\d)(\d{3}){2}(\w{0,1})$/)) {
              value = value.replace(/^(\d)(\d{3})(\d{3})(\w{0,1})$/, '$1.$2.$3-$4');
            }
            else if (value.match(/^(\d)(\d{3})(\d{0,2})$/)) {
              value = value.replace(/^(\d)(\d{3})(\d{0,2})$/, '$1.$2.$3');
            }
            else if (value.match(/^(\d)(\d{0,2})$/)) {
              value = value.replace(/^(\d)(\d{0,2})$/, '$1.$2');
            }

            this.form_onboarding.merchant_rut = value
            if (this.form_onboarding.merchant_rut.length >= 11) {
              this.validateFormatRut()
            }
          }
        } else {
          this.form_onboarding.merchant_rut = event.target.value.substring(0, event.target.value.length - 1)
        }
      }
    },
    validateFormatRut() {
      let valor = ''
      valor = this.form_onboarding.merchant_rut.replace(/\./g, '').replace('-', '')
      let bodyRut = valor.slice(0, -1);
      let dv = valor.slice(-1).toUpperCase();
      let suma = 0;
      let multiplo = 2;

      for (let i = 1; i <= bodyRut.length; i++) {
        let index = multiplo * valor.charAt(bodyRut.length - i);
        suma = suma + index;
        if (multiplo < 7) {
          multiplo = multiplo + 1;
        } else {
          multiplo = 2;
        }
      }
      let dvEsperado = 11 - (suma % 11);
      dv = dv == "K" ? 10 : dv;
      dv = dv == 0 ? 11 : dv;
      if (dvEsperado != dv) {
        this.errors.merchant_rut = 'Rut ingresado no es válido'
      } else {
        this.errors.merchant_rut = ''
      }
    },
    deleteLetters(endChar) {
      let formatNumber = false;
      if (isNaN(endChar)) {
        if (endChar == 'K' || endChar == 'k' || endChar == '-') {
          formatNumber = true
        } else {
          formatNumber = false
        }
      } else {
        formatNumber = true
      }
      return formatNumber
    },
    formatRutToSubmit(rut) {
      let output = rut.replace(/\./g, "");
      return output
    },
    validateErrors() {
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key) && this.errors[key] !== '') {
          return false
        }
      }
      return true
    },
    handlePaste(event) {
      event.preventDefault();
    }
  },
  computed: {
  },
  mounted() {
    if (this.register == 'register') {
      this.buttonBack = 'Ir a inicio de sesión'
      this.showRegister()
    }

  },
}
</script>
<style>
label .checkbox {
  margin-right: 5px
}
.svg-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.svg-content {
  width: 40%;
  margin-left: 1rem;
  height: auto;
}
</style>